import { z } from 'zod';
import { agentIdSchema, agentStatusCodeSchema } from './agent.schemas.js';
import { missionIdSchema, missionStatusCodeSchema } from '../mission/mission.schemas.js';
import { isoUtcDateTimeSchema } from '../shared/schemas.js';

// Agent d'une operation vu par son organisateur (backoffice) : identite,
// statuts de l'agent et de sa mission, score et fin de mission.
export const operationAgentSchema = z.object({
  agentId: agentIdSchema,
  missionId: missionIdSchema,
  firstName: z.string(),
  codeName: z.string(),
  agentStatusCode: agentStatusCodeSchema,
  missionStatusCode: missionStatusCodeSchema,
  score: z.number().int().nonnegative(),
  joinedAt: isoUtcDateTimeSchema,
  endedAt: isoUtcDateTimeSchema.nullable(),
});

export type OperationAgent = z.infer<typeof operationAgentSchema>;
